import { Dropdown, Tooltip } from 'antd'
import {
  ActionMenu,
  ButtonText,
  ItemDeleteText,
  ItemText,
  Main,
  SmallButtons,
  StyledDropDownButton,
  ViewButton,
} from 'components/ActionStyles/ActionStyles'
import DownArrow from 'components/icons/DownArrow'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import React from 'react'
import { EmptyAnchor } from '../../../../../components/UIComponents/CommonStyledDiv'

const ActionDropdown = ({
  veiwButton = true,
  jobId,
  data,
  onEditClick,
  onActionsClick,
  onViewClick,
  permittedEvents,
}) => {
  let menuItems = [
    {
      key: 'edit',
      label: <ItemText>Edit & Update</ItemText>,
      hidden:
        !permittedEvents?.includes('EDIT') &&
        !permittedEvents?.includes('EDIT & UPDATE'),
      onClick: () =>
        onEditClick(jobId, data?.status == 1 ? 'active' : 'draft', data),
      style: {
        display: data?.status == 0 || data?.status == 1 ? 'block' : 'none',
      },
    },
    {
      key: 'close',
      label: (
        <ItemText>
          {data?.status == '-1' ? 'Closed' : 'Close Application'}
        </ItemText>
      ),
      hidden:
        data?.status == 0
          ? true
          : !permittedEvents?.includes('CLOSE APPLICATION'),
      onClick: () => onActionsClick(jobId, 'close'),
      disabled: data?.status == '-1',
    },
    {
      key: 'duplicate',
      hidden: !permittedEvents?.includes('DUPLICATE'),
      label: <ItemText>Duplicate</ItemText>,
      onClick: () => onActionsClick(jobId, 'duplicate'),
    },
    {
      type: 'divider',
      hidden: !permittedEvents?.includes('DELETE'),
    },
    {
      key: 'delete',
      hidden: !permittedEvents?.includes('DELETE'),
      label: <ItemDeleteText>Delete</ItemDeleteText>,
      onClick: () => onActionsClick(jobId, 'delete'),
    },
  ]?.filter(item => !item.hidden)
  const menu = <ActionMenu width={'190px'} items={menuItems} />
  return (
    <Main id="view_dropdown">
      {veiwButton ? (
        <>
          {menuItems?.length ? (
            <StyledDropDownButton
              overlay={menu}
              shape="round"
              trigger={['click']}
              icon={<DownArrow />}
              getPopupContainer={() => document.getElementById('view_dropdown')}
            >
              <Tooltip title={data?.status == 0 ? 'Not published yet' : ''}>
                <ButtonText
                  disabled={data?.status == 0}
                  onClick={() => onViewClick(jobId)}
                >
                  View
                </ButtonText>
              </Tooltip>
            </StyledDropDownButton>
          ) : (
            <Tooltip title={data?.status == 0 ? 'Not published yet' : ''}>
              <ViewButton
                disabled={data?.status == 0}
                onClick={() => onViewClick(jobId)}
                text={'View'}
                height="32px"
              />
            </Tooltip>
          )}
        </>
      ) : (
        <Dropdown overlay={menu} trigger={['click']}>
          <EmptyAnchor onClick={e => e.preventDefault()}>
            <SmallButtons
              width={'40px'}
              height={'38px'}
              icon={<VerticalThreeDots />}
            />
          </EmptyAnchor>
        </Dropdown>
      )}
    </Main>
  )
}

export default ActionDropdown
